// extracted by mini-css-extract-plugin
module.exports = {"text":"ActivateServiceByLowCredit_text__1B2DC","submitBtn":"ActivateServiceByLowCredit_submitBtn__2vRsv","btn":"ActivateServiceByLowCredit_btn__1nD1p"};